import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import NavBar from './components/NavBar';
import Home from './components/Home';
import AdoptPet from './components/Adopter/AdoptPet';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import PetDetails from './components/Adopter/PetDetails';
import ApplicationForm from './components/Adopter/ApplicationForm';
import ApplicationStatus from './components/Adopter/ApplicationStatus';
import ChatBot from './components/Adopter/ChatBot';
import AboutUs from './components/Adopter/AboutUs';
import LostFound from './components/Adopter/LostFound';
import LostFoundDetails from './components/Adopter/LostFoundDetails';
import { LoadingProvider, useLoading } from './components/Loading';
import MyPosts from './components/Adopter/MyPosts';
import MyApplication from './components/Adopter/MyApplications';
import Profile from './components/Adopter/Profile';
import NewPost from './components/Adopter/NewPost';
import EditPost from './components/Adopter/EditPost';
import SideBar from './components/Shelter/SideBar';
import ShelterDashboard from './components/Shelter/ShelterDashboard';
import PetList from './components/Shelter/PetList';
import ApplicantList from './components/Shelter/ApplicantList';
import AppointmentList from './components/Shelter/AppointmentList';
import FinalApproval from './components/Shelter/FinalApproval';
import AddNewPet from './components/Shelter/AddNewPet';
import EditPet from './components/Shelter/EditPet';
import ProtectedRoute from './components/ProtectedRoute';
import { useEffect } from 'react';
import ShelterProfile from './components/Shelter/ShelterProfile';
import TermsAndConditions from './components/Terms&Conditions';
import Privacy from './components/Privacy';

function App() {
  return (

    <BrowserRouter>
      <LoadingProvider>
        <MainApp />
      </LoadingProvider>
    </BrowserRouter>

  );
}

// Separate MainApp to use useLocation correctly
function MainApp() {
  const location = useLocation();
  const validPaths = [
    "/", "/login", "/register", "/forgot-password", "/adopt", "/chatbot",
    "/about-us", "/lost-found", "/my-posts", "/my-applications", "/profile",
    "/new-post", "/pet-details/:id", "/application-form/:id",
    "/application-status/:id", "/lost-found-details/:id", "/edit-post/:id",
    "/shelter-dashboard", "/shelter-pet-list", "/shelter-application-list",
    "/shelter-appointment-list", "/shelter-final-approval",
    "/shelter-add-pet", "/shelter-edit-pet/:id", "/shelter-profile"
  ];

  // Check if the current path is not valid (404 page)
  const isNotFound = !validPaths.some(path => 
    new RegExp(`^${path.replace(/:\w+/g, ".*")}$`).test(location.pathname)
  );
  const hideNavbar = ['/login', '/register', '/forgot-password'].includes(location.pathname)||isNotFound;


  return (
    <div className="App">
      {(!hideNavbar)&& <NavBar />}
      <div className={ (location.pathname.includes("shelter")  && !isNotFound) ? "shelterRoutes" : ""}>
      { location.pathname.includes("shelter") &&  !isNotFound&&
            <SideBar/>}
        
          <Routes>
            {/* Adopter Routes */}
            <Route path="/" element={<ProtectedRoute requiredRole="adopter"><Home /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/adopt" element={<ProtectedRoute requiredRole="adopter"><AdoptPet /></ProtectedRoute>} />
            <Route path="/chatbot" element={<ProtectedRoute requiredRole="adopter"><ChatBot /></ProtectedRoute>} />
            <Route path="/about-us" element={<ProtectedRoute requiredRole="adopter"><AboutUs /></ProtectedRoute>} />
            <Route path="/lost-found" element={<ProtectedRoute requiredRole="adopter"><LostFound /></ProtectedRoute>} />
            <Route path="/my-posts" element={<ProtectedRoute requiredRole="adopter"><MyPosts /></ProtectedRoute>} />
            <Route path="/my-applications" element={<ProtectedRoute requiredRole="adopter"><MyApplication /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute requiredRole="adopter"><Profile/></ProtectedRoute>} />
            <Route path="/new-post" element={<ProtectedRoute requiredRole="adopter"><NewPost/></ProtectedRoute>} />
            <Route path="/terms" element={<TermsAndConditions/>} />
            <Route path="/privacy" element={<Privacy/>} />
            <Route path="/pet-details/:id" element={<ProtectedRoute requiredRole="adopter"><PetDetails /></ProtectedRoute>} />
            <Route path="/application-form/:id" element={<ProtectedRoute requiredRole="adopter"><ApplicationForm /></ProtectedRoute>} />
            <Route path="/application-status/:id" element={<ProtectedRoute requiredRole="adopter"><ApplicationStatus /></ProtectedRoute>} />
            <Route path="/lost-found-details/:id" element={<ProtectedRoute requiredRole="adopter"><LostFoundDetails /></ProtectedRoute>} />
            <Route path="/edit-post/:id" element={<ProtectedRoute requiredRole="adopter"><EditPost/></ProtectedRoute>} />

            {/* Shelter Routes */}
            <Route path="/shelter-dashboard" element={<ProtectedRoute requiredRole="shelter"><ShelterDashboard/></ProtectedRoute>} />
            <Route path="/shelter-pet-list" element={<ProtectedRoute requiredRole="shelter"><PetList/></ProtectedRoute>} />
            <Route path="/shelter-application-list" element={<ProtectedRoute requiredRole="shelter"><ApplicantList/></ProtectedRoute>} />
            <Route path="/shelter-appointment-list" element={<ProtectedRoute requiredRole="shelter"><AppointmentList/></ProtectedRoute>} />
            <Route path="/shelter-final-approval" element={<ProtectedRoute requiredRole="shelter"><FinalApproval/></ProtectedRoute>} />
            <Route path="/shelter-add-pet" element={<ProtectedRoute requiredRole="shelter"><AddNewPet/></ProtectedRoute>} />
            <Route path="/shelter-profile" element={<ProtectedRoute requiredRole="shelter"><ShelterProfile/></ProtectedRoute>} />
            <Route path="/shelter-edit-pet/:id" element={<ProtectedRoute requiredRole="shelter"><EditPet/></ProtectedRoute>} />

            {/* Not Found Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
    

    </div>
  );
}

function NotFound() {
  const { setLoading } = useLoading();
  useEffect(() => {
    setTimeout(()=>{
      setLoading(false);
    },10);
    
  }, [setLoading]);
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  )
}

export default App;
